import { render, staticRenderFns } from "./rulerManagement.vue?vue&type=template&id=63e275e4&"
import script from "./rulerManagement.vue?vue&type=script&lang=js&"
export * from "./rulerManagement.vue?vue&type=script&lang=js&"
import style0 from "./rulerManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports